import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { autobind } from 'core-decorators';
import styled from 'styled-components';
import request from 'superagent';

import Dialog, {
  Tabs,
  Tab,
  TabContent,
} from '../../../common/components/dialog/Dialog';
import SocialButton from '../../../common/components/SocialButton';
import * as navigationActions from '../../../common/actions/navigationActions';
import utils from '../../../common/utils';

const SectionContainer = styled.div`
  position: relative;
  margin-bottom: ${props => (props.last ? '0' : '20px')};
`;

const Label = styled.strong`
  display: block;
  font-size: 16px;
  line-height: 1em;
  font-weight: 500;
  margin-bottom: 10px;
`;

const SocialButtons = styled.div`
  display: flex;
`;

const Copied = styled.span`
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  color: var(--textSecondaryColor);
`;

const Button = styled.button`
  position: absolute;
  right: 0;
  top: 0;
  font-size: 12px;
  height: 16px;
  line-height: 16px;
  border: 0;
  background: transparent none;
  outline: none;
  cursor: pointer;
  color: var(--primaryColor);
  :hover {
    background: transparent;
  }
`;

const Input = styled.input.attrs({ type: 'text' })`
  display: block;
  width: 100%;
  height: 26px;
  line-height: 26px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  padding: 0 5px;
  outline: none;
  resize: vertical;
`;

const Textarea = styled.textarea`
  display: block;
  width: 100%;
  height: 112px;
  line-height: 1.4em;
  font-family: Monaco, monospace;
  font-size: 12px;
  padding: 5px;
  outline: none;
  resize: vertical;
`;

class ShareDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentTab: 'social',
      copiedUrl: false,
      copiedEmbedCode: false,
      fetchedUrl: false,
      url: window.url,
    };

    const titleMeta = document.querySelector("meta[property='og:title']");

    if (titleMeta) {
      this.title = titleMeta.getAttribute('content');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.visible && this.props.visible && !this.state.fetchedUrl) {
      request
        .get(`/${window.presentationId}/info`)
        .set('Accept', 'application/json')
        .end((error, response) => {
          if (!error) {
            this.setState({
              url: response.body.url,
              fetchedUrl: true,
            });
          }
        });
    }
  }

  @autobind
  clickTabSocial() {
    this.setState({ currentTab: 'social' });
  }

  @autobind
  clickTabEmbed() {
    this.setState({ currentTab: 'embed' });
  }

  @autobind
  copyUrl() {
    this.setState({ copiedUrl: true });
    utils.copy(this.url.value);
    setTimeout(() => {
      this.setState({ copiedUrl: false });
    }, 1000);
  }

  @autobind
  copyEmbedCode() {
    this.setState({ copiedEmbedCode: true });
    utils.copy(this.embedCode.value);
    setTimeout(() => {
      this.setState({ copiedEmbedCode: false });
    }, 1000);
  }

  @autobind
  shareOnFacebook() {
    this.props.actions.sharePresentationOnFacebook(this.state.url);
  }

  @autobind
  shareOnTwitter() {
    this.props.actions.sharePresentationOnTwitter(this.title, this.state.url);
  }

  @autobind
  shareOnLinkedin() {
    this.props.actions.sharePresentationOnLinkedin(this.title, this.state.url);
  }

  @autobind
  shareByEmail() {
    this.props.actions.sharePresentationByEmail(this.title, this.state.url);
  }

  render() {
    const embedCode = `<div style="position:relative;padding-bottom:calc(${(window
      .documentSize.height /
      window.documentSize.width) *
      100}% + 58px);height:0;overflow:hidden;max-width:100%;"><iframe src="${
      this.state.url
    }" frameborder="0" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>`;
    const url = this.state.url;

    return (
      <Dialog visible={this.props.visible} onClose={this.props.onClose}>
        <Tabs>
          <Tab
            selected={this.state.currentTab === 'social'}
            onClick={this.clickTabSocial}
          >
            Social
          </Tab>
          <Tab
            selected={this.state.currentTab === 'embed'}
            onClick={this.clickTabEmbed}
          >
            Embed
          </Tab>
        </Tabs>
        <TabContent visible={this.state.currentTab === 'social'}>
          <SectionContainer>
            <Label>Pick where you want to share it...</Label>
            <SocialButtons>
              <SocialButton color="facebook" onClick={this.shareOnFacebook}>
                <i className="icon-fb_icn" />
              </SocialButton>
              <SocialButton color="twitter" onClick={this.shareOnTwitter}>
                <i className="icon-twitter_icn" />
              </SocialButton>
              <SocialButton color="linkedin" onClick={this.shareOnLinkedin}>
                <i className="icon-linkedin-outline" />
              </SocialButton>
              <SocialButton color="middleGrey" onClick={this.shareByEmail}>
                <i className="icon-mail_icn" />
              </SocialButton>
            </SocialButtons>
          </SectionContainer>
          <SectionContainer last className="inputField">
            <Label>...or just copy the public URL</Label>
            {this.state.copiedUrl ? (
              <Copied>Copied!</Copied>
            ) : (
              <Button onClick={this.copyUrl}>Copy</Button>
            )}
            <Input
              ref={el => {
                this.url = el;
              }}
              value={url}
              onFocus={e => e.target.select()}
              readOnly
            />
          </SectionContainer>
        </TabContent>
        <TabContent visible={this.state.currentTab === 'embed'}>
          <SectionContainer last className="inputField">
            <Label>Embed</Label>
            {this.state.copiedEmbedCode ? (
              <Copied>Copied!</Copied>
            ) : (
              <Button onClick={this.copyEmbedCode}>Copy</Button>
            )}
            <Textarea
              ref={el => {
                this.embedCode = el;
              }}
              value={embedCode}
              onFocus={e => e.target.select()}
              readOnly
            />
          </SectionContainer>
        </TabContent>
      </Dialog>
    );
  }
}

ShareDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
};

export default connect(null, dispatch => ({
  actions: bindActionCreators(navigationActions, dispatch),
}))(ShareDialog);
